<template>
  <div
    :class="['chat', !detectMob ? 'd-none-mobile' : ''].join(' ')"
    :title="String($t('accessibilityTexts.title.chat'))"
    v-if="getShowChat"
  >
    <button
      v-if="getShowWhatsapp"
      class="mdn-Button mdn-Button--icon mdn-Button--primary mb-3 green"
      aria-label="Icon"
      v-show="open"
      @click="openWhats"
    >
      <span class="mdn-Icon-whatsapp mdn-Icon--lg"></span>
    </button>
    <button
      v-if="isChatEnabled && getShowChatButton"
      class="mdn-Button mdn-Button--icon mdn-Button--primary mb-3"
      aria-label="Icon"
      v-show="open"
      @click="chat = !chat"
    >
      <span class="mdn-Icon-chat mdn-Icon--lg"></span>
    </button>
    <div class="btn">
      <p class="mdn-Text mdn-Text--body mr-3 mt-3" v-show="!open">
        <b>Ajuda Online</b>
      </p>
      <button
        :class="
          'mdn-Button mdn-Button--icon ' +
          (open ? 'mdn-Button--secondary branco' : 'mdn-Button--primary')
        "
        aria-label="Icon"
        @click="open = !open"
      >
        <span :class="`mdn-Icon-${open ? 'fechar' : 'chat'} mdn-Icon--lg`" />
      </button>
    </div>
    <div :class="'frame-chat ' + (chat ? 'enabled' : '')">
      <span class="mdn-Icon-baixo mdn-Icon--md" @click="chat = !chat"></span>
      <iframe
        title="chatframe"
        :src="iframeUrlChat"
        allow="geolocation"
      ></iframe>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { getTokenChat } from "@/services/Chat";
import { Action, Getter } from "vuex-class";
import { ActionMethod } from "vuex";

@Component({
  name: "Chat",
})
export default class Chat extends Vue {
  @Action setChatData!: ActionMethod;
  @Getter readonly chatToken!: string;
  @Getter readonly expirationDate!: string;
  @Getter readonly getShowChat!: string;
  @Getter readonly getShowWhatsapp!: string;
  @Getter readonly getShowChatButton!: string;
  @Getter readonly getUrlChat!: string;
  open = false;
  chat = false;
  isChatEnabled = false;
  iframeUrlChat = "";

  get detectMob() {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i,
    ];

    return toMatch.some((toMatchItem) => {
      return navigator.userAgent.match(toMatchItem);
    });
  }

  isDateExpirated() {
    if (this.expirationDate && this.expirationDate !== "") {
      const [date, time] = this.expirationDate.split(" ");
      const [day, month, year] = date.split("/").map(Number);
      const [hour, minutes, seconds] = time.split(":").map(Number);
      const today = new Date();
      const limitDate = new Date(year, month - 1, day, hour, minutes, seconds);

      if (today > limitDate) {
        return true;
      }
    }
    return false;
  }

  async updateToken() {
    try {
      const data = await getTokenChat();
      this.setChatData(data);

      this.iframeUrlChat = `${this.getUrlChat}?token=${data.token}&appOrigem=Flex`;
    } catch (error) {
      console.log("Erro ao carregar dados do Chat");
    }
  }

  async validateToken() {
    if (this.chatToken && this.chatToken !== "") {
      if (this.isDateExpirated()) {
        this.updateToken();
      }
    } else {
      this.updateToken();
    }
  }

  @Watch("open")
  async onOpenChanged() {
    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.open ? "ajuda:abrir" : "ajuda:fechar",
      });
    }
  }

  @Watch("chat")
  async onChatChanged(chatIsOpen: boolean) {
    if (chatIsOpen) {
      this.validateToken();
    }

    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: this.chat ? "chat:abrir" : "chat:fechar",
      });
    }
  }

  openWhats(): void {
    if (this.$gtm.enabled()) {
      window.dataLayer?.push({
        event: "event",
        eventCategory:
          this.$route.fullPath === "/"
            ? "claro-flex:home"
            : "claro-flex:checkout",
        eventAction: "clique:botao",
        eventLabel: "ajuda:whatsapp",
      });
    }
    window.open(process.env.VUE_APP_API_WHATSAPP, "_blank");
  }

  async created() {
    this.isChatEnabled = this.$router.currentRoute.name !== "NcndLink";
  }
}
</script>
<style lang="scss" scoped>
.chat {
  position: fixed;
  bottom: var(--spacing-stack-xxl);
  right: var(--spacing-stack-xs);
  display: flex;
  flex-direction: column;
  z-index: 1041;
  .mdn-Button--icon {
    width: var(--spacing-stack-xl) !important;
    height: var(--spacing-stack-xl) !important;
  }
  .green {
    background-color: var(--color-support-success-dark);
  }
  .branco {
    background-color: var(--color-neutral-lightest);
  }
  .btn {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.frame-chat {
  position: fixed;
  bottom: var(--spacing-stack-xxl);
  right: var(--spacing-stack-xs);
  opacity: 0;
  visibility: hidden;
  transition: opacity 500ms, transform 500ms, visibility 500ms, height 0s 500ms;
  transform: translateY(10%);
  z-index: 1000001;
  height: 0;
  width: 400px;
  box-shadow: 0 0 20px 1px rgb(0 0 0 / 20%);
  border-radius: var(--border-radius-sm);
  background: var(--color-neutral-lightest);
  display: flex;
  flex-direction: column;
  text-align: right;
  span {
    color: var(--color-brand-primary-medium);
    cursor: pointer;
  }

  @media screen and (max-width: 380px), screen and (max-height: 320px) {
    right: 0 !important;
    bottom: 0 !important;
    max-height: 100vh !important;
    width: 100vw !important;
    height: 100% !important;
  }

  &.enabled {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
    transition: opacity 500ms 10ms, transform 500ms 10ms, visibility 500ms 10ms,
      height 0ms;
    height: 410px;
    iframe {
      height: 410px;
    }
  }
}
</style>
